
        function updateTimer() {
            // Obter hora atual
            const now = new Date();
            
            // Criar objeto para meia-noite de hoje
            const midnight = new Date();
            midnight.setHours(24, 0, 0, 0); // Meia-noite do próximo dia
            
            // Calcular diferença em milissegundos
            const diff = midnight - now;
            
            // Converter para segundos totais
            const totalSeconds = Math.floor(diff / 1000);
            
            if (totalSeconds <= 0) {
                // Se chegou a meia-noite, mostrar zeros momentaneamente
                document.getElementById('hours').textContent = '00';
                document.getElementById('minutes').textContent = '00';
                document.getElementById('seconds').textContent = '00';
                return;
            }

            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            document.getElementById('hours').textContent = hours.toString().padStart(2, '0');
            document.getElementById('minutes').textContent = minutes.toString().padStart(2, '0');
            document.getElementById('seconds').textContent = seconds.toString().padStart(2, '0');
        }

        // Atualizar a cada segundo
        setInterval(updateTimer, 1000);
        
        // Primeira atualização imediata
        updateTimer();
    